angular.module('trainerWebApp.consts').constant('gac', {
  pages: {
    trainerWeb: {
      name: "TRAINER_WEB",
      actions: {
        sendFeedback: "SendFeedback",
        manageUsersDropDownLinkClicked: "manage_users_dropdown_link_clicked",
        pickPlanLightboxOpened: "Pick_Plan_Lightbox_Opened"
      }
    },
    seriesDashboard: {
      name: "SERIES_DASHBOARD",
      actions: {
        viewGoodDataCourseReport: "ViewGoodDataSeriesReport"
      }
    },
    seriesManage:{
      name: "SERIES_MANAGE",
      actions: {
        enforceCourseSequence: "EnforceCourseSequence"
      }
    },
    seriesTrainees:{
      name: "SERIES_TRAINEES",
      actions: {
        //
      }
    },
    seriesCustomize:{
      name: "SERIES_CUSTOMIZE",
      actions: {
        passingScore: "PassingScore",
        retakeEnabled: "RetakeEnabled",
        updateSensionUsage: "updateSensionUsage",
        issueCertificatesPerCourse: "IssueCertificatesPerCourse",
        issueCertificatesForSeries: "issueCertificatesForSeries",
        showSeriesScoreOnCertificates: "showSeriesScoreOnCertificates",
        updateAccessType: "updateAccessType",
        yammerSharesEnabledChanged: "yammerSharesEnabledChanged",
        getUrlToShareSeries: "getUrlToShareSeries",
        emailLinkToSeries: "emailLinkToSeries",
        shareToYammer: "shareToYammer",
        shareToLinkedin: "shareToLinkedin",
        shareToFacebook: "shareToFacebook",
        shareToTwitter: "shareToTwitter",
        completionDeadlineEnabled: "completionDeadlineEnabled",
        completionDeadlineDisabled: "completionDeadlineDisabled"
      }
    },
    courseTrainees:{
      name: "COURSE_TRAINEES",
      actions: {
      }
    },
    getStarted:{
      name: "GET_STARTED",
      actions: {
        GettingStarted: "GettingStarted",
        GettingStarted_FindFile: "GettingStarted_FindFile",
        GettingStarted_BuildingCourseLoader: "GettingStarted_BuildingCourseLoader",
        GettingStarted_Tour_Video: "GettingStarted_Tour_Video",
        GettingStarted_SkipToHome: "GettingStarted_SkipToHome",
        GettingStarted_UseSample: "GettingStarted_UseSample",
        GettingStarted_Interaction: "GettingStarted_Interaction",
        GettingStarted_CreatePageButton: "GettingStarted_CreatePageButton",
        GettingStarted_DistributePageButton: "GettingStarted_DistributePageButton",
        GettingStarted_TrackPageButton: "GettingStarted_TrackPageButton",
        GettingStartedCreatePage: "GettingStartedCreatePage",
        GettingStartedCreatePage_StartCreatingCourses: "GettingStartedCreatePage_StartCreatingCourses",
        GettingStartedCreatePage_DistributePageButton: "GettingStartedCreatePage_DistributePageButton",
        GettingStartedDistributePage: "GettingStartedDistributePage",
        GettingStartedDistributePage_StartImportingUsersButton: "GettingStartedDistributePage_StartImportingUsersButton",
        GettingStartedDistributePage_TrackPageButton: "GettingStartedDistributePage_TrackPageButton",
        GettingStartedTrackPage: "GettingStartedTrackPage",
        GettingStartedTrackPage_GetStartedButton: "GettingStartedTrackPage_GetStartedButton"
      }
    },
    usersManage: {
      name: "USERS_MANAGE",
      actions: {
        viewGoodDataUsersReport: "ViewGoodDataUsersReport",
        modifyGroupsForUser: "ModifyGroupsForUser",
        modifyCoursesAndSeriesForUser: "ModifyCourseAndSeriesForUser",
        searchByAllFields: "SearchByAllFields",
        searchByName: "SearchByName",
        searchByEmail: "SearchByEmail",
        searchByCustomField: "SearchByCustomField",
        searchByGroup: "SearchByGroup",
        searchForUngrouped: "SearchForUngrouped",
        searchByCourse: "SearchByCourse",
        searchBySeries: "SearchBySeries",
        searchByUsername: "SearchByUsername",
        compositeSearch: "CompositeSearch",
        openCourseAction: "user_management_action_nav_ocd",
        openSeriesAction: "user_management_action_nav_ocd",
        filterByCourseAction: "user_management_action_filter_course_series",
        filterBySeriesAction: "user_management_action_filter_course_series"
      }
    },
    featurePreview: {
      name: "FEATURE_PREVIEW",
      actions: {
        upgradeAction: "featurepreview_action_upgrade",
        interestAction: "featurepreview_action_interest"
      }
    },
    trainerHome: {
      name: "TRAINER_HOME",
      actions: {
        openCourseAction: "home_action_nav_ocd",
        openSeriesAction: "home_action_nav_ocd",
        openCatalogAction: "home_action_nav_ocd",
        deleteSeriesAction: "home_action_delete_series",
        deleteCourseAction: "home_action_delete_course",
        deleteCatalogAction: "home_action_delete_catalog",
        copyCourseAction: "home_action_copy_course",
        gotoCourseAction: "home_action_goto_course",
        gotoSeriesAction: "home_action_goto_series",
        manageCourseTraineesAction: "home_action_manage_trainees_course",
        manageCourseInvitedStateAction: "home_action_manage_invited_course",
        manageCourseStartedStateAction: "home_action_manage_started_course",
        manageCourseMissedDeadlineStateAction: "home_action_manage_missed_deadline_course",
        manageCoursePassedStateAction: "home_action_manage_passed_course",
        manageCourseFailedStateAction: "home_action_manage_failed_course",
        manageSeriesTraineesAction: "home_action_manage_trainees_series",
        manageSeriesInvitedStateAction: "home_action_manage_invited_series",
        manageSeriesStartedStateAction: "home_action_manage_started_series",
        manageSeriesMissedDeadlineStateAction: "home_action_manage_missed_deadline_series",
        manageSeriesPassedStateAction: "home_action_manage_passed_series",
        manageSeriesFailedStateAction: "home_action_manage_failed_series",
        manageUsersButtonClicked: "manage_users_button_clicked",
        filterByCourseAction: "home_action_filter_course_series",
        searchByCourse: "home_search_by_course",
        searchBySeries: "home_search_by_series",
        searchByCatalog: "home_search_by_catalog",
        searchByTrainerName: "home_search_by_trainer_name",
        searchByTrainerEmail: "home_search_by_trainer_email",
        viewChangeToList: "home_view_change_to_list",
        viewChangeToTile: "home_view_change_to_tile",
        searchFilterStatusAll: "home_filter_status_all",
        searchFilterStatusDraft: "home_filter_status_draft",
        searchFilterStatusActive: "home_filter_status_active",
        searchFilterStatusArchive: "home_filter_status_archive",
        searchFilterTypeAll: "home_filter_type_all",
        searchFilterTypeCourse: "home_filter_type_course",
        searchFilterTypeSeries: "home_filter_type_series",
        listSearchSortName: "home_list_sort_name",
        listSearchSortType: "home_list_sort_type",
        listSearchSortStatus: "home_list_sort_status",
        listSearchSortModified: "home_list_sort_modified",
        listSearchSortTrainerName: "home_list_sort_trainer_name",
        tileSearchSortName: "home_tile_sort_name",
        tileSearchSortModified: "home_tile_sort_modified",
        tileSearchSortTrainerName: "home_tile_sort_trainer_name",
        pokeRemindCourseTrainees: "home_action_poke_remind_course_trainees",
        pokeRemindSeriesTrainees: "home_action_poke_remind_series_trainees",
        resetCourseTrainees: "home_action_reset_course_trainees",
        resetSeriesTrainees: "home_action_reset_series_trainees"
      }
    }
  }
});
